import api from "./client";

export async function getRawMaterialsMeta({ refresh = false } = {}) {
  const qs = refresh ? "?refresh=1" : "";
  const res = await api.get(`/raw-materials/meta${qs}`);
  return res.data.data;
}

export async function previewRawMaterial(type, payload) {
  const res = await api.post(`/raw-materials/${encodeURIComponent(String(type))}/preview`, payload || {});
  return res.data.data; // { stock_code, unit, material_id, base_code, internal_code }
}

export async function receiveRawMaterial(type, payload) {
  const res = await api.post(`/raw-materials/${encodeURIComponent(String(type))}/receive`, payload || {});
  return res.data.data; // { material_id, material_variant_id, base_code, internal_code, stock_code_preview, unit, lot_no, inventory_tx_id }
}

export async function listInkLots() {
  const res = await api.get(`/raw-materials/ink/lots`);
  return res.data.data; // [{ material_id, material_variant_id, material_code, material_unit, lot_no, on_hand_qty, expiry_date, color_name, pantone_code, material_variant_display_name }]
}

export async function getInkOptions() {
  const res = await api.get(`/raw-materials/ink/options`);
  return res.data.data; // { color_names: string[], pantone_codes: string[] }
}

export async function mixInkLots(payload) {
  const res = await api.post(`/raw-materials/ink/mix`, payload || {});
  return res.data.data; // { ink_mix_id, output: { material_id, stock_code, lot_no, qty, uom, inventory_tx_id } }
}

export async function listBaseRawMaterials(type) {
  const data = await listBaseRawMaterialsPaged(type);
  return data.items; // [{ id, code, internal_code, name, unit }]
}

export async function listBaseRawMaterialsPaged(type, { page, limit, search } = {}) {
  const res = await api.get(`/raw-materials/${encodeURIComponent(String(type))}/base-materials`, {
    params: { page, limit, search },
  });
  return res.data.data;
}

